import React, { useState, useEffect } from 'react'
import PureTitle from '../PureTitle'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import parentStyles from '../../styles.module.scss'
import Label from 'srcReact/components/common2/Label'
import Input from 'srcReact/components/common2/Input'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import { useDispatch, useSelector } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { isEmpty } from 'srcReact/helpers/validator'
import { isNum } from 'srcReact/helpers/utils'

function MixrAttendance({ editMode, previewEditMode }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [inPersonLimitRef, setInPersonLimitRef] = useState(null)
  const [virtualLimitRef, setVirtualLimitRef] = useState(null)
  const [valueChanged, setValueChanged] = useState(false)
  const [inPersonLimit, setInPersonLimit] = useState({
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: false
  })
  const [virtualLimit, setVirtualLimit] = useState({ value: '', hasError: false, errorMessage: '', isRequired: false })

  const [mixrAttendanceLimit, setMixrAttendanceLimit] = useState([
    { type: 'in_person', limit: '' },
    { type: 'virtual', limit: '' }
  ])
  const [attendanceLimit, setAttendanceLimit] = useState([
    {
      value: 0,
      label: t('event.create.none')
    },
    {
      value: 1,
      label: t('global.yes')
    }
  ])

  const [selectedAttendanceLimit, setSelectedAttendanceLimit] = useState({
    value: 0,
    label: t('event.create.none')
  })
  const [selectedVenueTypeForLimit, setSelectedVenueTypeForLimit] = useState({
    value: 'in_person',
    label: t('event.create.venue.venueInPerson')
  })

  const {
    mixr: {
      mixr: { attendance_limits, attending_type }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (attendance_limits && attendance_limits.length > 0) {
      setSelectedAttendanceLimit({
        value: 1,
        label: t('global.yes')
      })
      setMixrAttendanceLimit(JSON.parse(JSON.stringify([...attendance_limits])))
      for (let i = 0; i < attendance_limits.length; i++) {
        if (attendance_limits[i].type === 'in_person') {
          setInPersonLimit({ ...inPersonLimit, value: attendance_limits[i].limit })
        }
        if (attendance_limits[i].type === 'virtual') {
          setVirtualLimit({ ...virtualLimit, value: attendance_limits[i].limit })
        }
      }
    } else {
      setSelectedAttendanceLimit({
        value: 0,
        label: t('event.create.none')
      })
      // setMixrAttendanceLimit([])
    }
  }, [attendance_limits])

  // useEffect(() => {
  //   if (attending_type) {
  //     console.log('attending type::', attending_type)
  //     processLimit(attending_type)
  //   }
  // }, [attending_type])

  const validate = () => {
    if (selectedAttendanceLimit.value === 1 && attending_type !== 'virtual') {
      const errorMessage = validateLimit(inPersonLimit.value)
      if (errorMessage && inPersonLimitRef && inPersonLimitRef.current) {
        inPersonLimitRef.current?.focus()
        setInPersonLimit({
          ...inPersonLimit,
          hasError: true,
          errorMessage: errorMessage
        })
        return false
      }
    }
    if (selectedAttendanceLimit.value === 1 && attending_type !== 'in_person') {
      const errorMessage = validateLimit(virtualLimit.value)
      if (errorMessage && virtualLimitRef && virtualLimitRef.current) {
        virtualLimitRef.current?.focus()
        setVirtualLimit({
          ...virtualLimit,
          hasError: true,
          errorMessage: errorMessage
        })
        return false
      }
    }
  }

  const handleAttendanceLimitChange = (limit) => {
    setValueChanged(true)
    setSelectedAttendanceLimit(limit)
    if (limit.value === 0) {
      setMixrAttendanceLimit([])
      console.log('setting:: 2')
      dispatch(mixrActions.setMixrData([{ key: 'attendance_limits', value: [] }]))
    }
  }

  const processLimit = (venue) => {
    //setSelectedVenueTypeForLimit(venue)
    const updated = [...mixrAttendanceLimit]
    for (let i = 0; i < updated.length; i++) {
      if (venue === 'in_person') {
        if (updated[i].type === 'virtual') {
          updated[i].limit = -1
        } else {
          updated[i].limit = inPersonLimit.value
        }
      } else if (venue === 'virtual') {
        if (updated[i].type === 'in_person') {
          updated[i].limit = -1
        } else {
          updated[i].limit = virtualLimit.value
        }
      } else {
        if (updated[i].type === 'in_person') {
          updated[i].limit = inPersonLimit.value
        }
        if (updated[i].type === 'virtual') {
          updated[i].limit = virtualLimit.value
        }
      }
    }
    setMixrAttendanceLimit([...updated])
    if (!editMode) {
      console.log('setting:: 3')
      dispatch(mixrActions.setMixrData([{ key: 'attendance_limits', value: [...updated] }]))
    }
  }

  const handleInpersonLimitChange = (e) => {
    setValueChanged(true)
    setInPersonLimit({
      ...inPersonLimit,
      value: e.target.value,
      hasError: false,
      errorMessage: ''
    })

    const updated = [...mixrAttendanceLimit]
    let hasInPersonValue = false
    for (let i = 0; i < updated.length; i++) {
      if (updated[i].type === 'in_person') {
        updated[i].limit = e.target.value
        hasInPersonValue = true
      }
    }
    if (!hasInPersonValue) {
      updated.unshift({ type: 'in_person', limit: e.target.value })
    }

    setMixrAttendanceLimit([...updated])

    if (!editMode) {
      console.log('setting:: 4')
      dispatch(mixrActions.setMixrData([{ key: 'attendance_limits', value: [...updated] }]))
    }
  }

  const handleInpersonLimitBlur = (e) => {
    const value = e.target.value
    const errorMessage = validateLimit(value)
    if (errorMessage) {
      setInPersonLimit({
        ...inPersonLimit,
        hasError: true,
        errorMessage: errorMessage
      })
    }
  }

  const handleVirtualLimitChange = (e) => {
    setValueChanged(true)
    setVirtualLimit({
      ...virtualLimit,
      value: e.target.value,
      hasError: false,
      errorMessage: ''
    })

    const updated = [...mixrAttendanceLimit]
    let hasVirtualValue = false
    for (let i = 0; i < updated.length; i++) {
      if (updated[i].type === 'virtual') {
        updated[i].limit = e.target.value
        hasVirtualValue = true
      }
    }
    if (!hasVirtualValue) {
      updated.push({ type: 'virtual', limit: e.target.value })
    }
    setMixrAttendanceLimit([...updated])
    if (!editMode) {
      console.log('setting:: 1')
      dispatch(mixrActions.setMixrData([{ key: 'attendance_limits', value: [...updated] }]))
    }
  }

  const handleVirtualLimitBlur = (e) => {
    const value = e.target.value
    const errorMessage = validateLimit(value)
    if (errorMessage) {
      setVirtualLimit({
        ...virtualLimit,
        hasError: true,
        errorMessage: errorMessage
      })
    }
  }

  const validateLimit = (value) => {
    let errorMessage = ''
    if (isEmpty(value)) {
      errorMessage = t('event.create.clientErrors.limitRequired')
    } else if (isNum(value) && value === 0) {
      errorMessage = t('event.create.clientErrors.limitInvalid')
    }
    return errorMessage
  }

  return (
    <React.Fragment>
      <PureTitle
        title={t('event.create.venue.attendanceLimitTitle')}
        isRequired={false}
        titleCss={parentStyles.titleCss}
      />
      <div className={`${styles.attendanceLimitMainContainer} ${parentStyles.full}`}>
        <div className={styles.attendanceLimitVenueSelectionContainer}>
          <div className={`${styles.attenLimit} ${styles.attenLimit1}`}>
            <Label ariaLabel={t('event.create.venue.attendanceLimit')} className={styles.attendanceLimitLabel}>
              {t('event.create.venue.attendanceLimit')}
            </Label>
            <Dropdown1
              size={'small'}
              value={selectedAttendanceLimit}
              options={attendanceLimit}
              className={styles.selectAttendanceLimitContainer}
              onChange={handleAttendanceLimitChange}
              isSearchable={false}
            />
          </div>
        </div>
        {selectedAttendanceLimit.value === 1 && (
          <div className={styles.attendanceLimitValueContainer}>
            {attending_type !== 'virtual' && (
              <div className={styles.limitValueContainer}>
                <div className={`${styles.attenLimit} ${attending_type !== 'both' && styles.attenLimitFull}`}>
                  <Label
                    ariaLabel={
                      attending_type === 'both'
                        ? t('event.create.venue.limitForInPerson')
                        : t('event.create.venue.limit')
                    }
                    className={`${styles.attendanceLimitLabel} ${styles.inpersonVirtualLimitLabel}`}>
                    {attending_type === 'both'
                      ? t('event.create.venue.limitForInPerson')
                      : t('event.create.venue.limit')}
                  </Label>
                  <Input
                    setRef={setInPersonLimitRef}
                    size='small'
                    type='number'
                    value={inPersonLimit.value}
                    onChange={handleInpersonLimitChange}
                    onBlur={handleInpersonLimitBlur}
                  />
                </div>
                {inPersonLimit && inPersonLimit.hasError && (
                  <ErrorMessage
                    text={inPersonLimit.errorMessage}
                    className={`${parentStyles.error} ${styles.limitError} ${attending_type === 'both' && styles.both}`}
                  />
                )}
              </div>
            )}
            {attending_type !== 'in_person' && (
              <div className={styles.limitValueContainer}>
                <div className={`${styles.attenLimit} ${attending_type !== 'both' && styles.attenLimitFull}`}>
                  <Label
                    ariaLabel={
                      attending_type === 'both'
                        ? t('event.create.venue.limitForVirtual')
                        : t('event.create.venue.limit')
                    }
                    className={`${styles.attendanceLimitLabel} ${styles.inpersonVirtualLimitLabel}`}>
                    {attending_type === 'both'
                      ? t('event.create.venue.limitForVirtual')
                      : t('event.create.venue.limit')}
                  </Label>
                  <Input
                    setRef={setVirtualLimitRef}
                    size='small'
                    type='number'
                    value={virtualLimit.value}
                    onChange={handleVirtualLimitChange}
                    onBlur={handleVirtualLimitBlur}
                  />
                </div>
                {virtualLimit && virtualLimit.hasError && (
                  <ErrorMessage
                    text={virtualLimit.errorMessage}
                    className={`${parentStyles.error} ${styles.limitError} ${attending_type === 'both' && styles.both}`}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default MixrAttendance
